module.exports = __webpack_public_path__ + "static/media/annotation.2d5c53ec.svg";